module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d2d3ca006dd41ad8f0dd3d2e69eedf73.png";